import { useState, useRef, useContext, useEffect, useMemo } from "react";
//import { usePrompt } from "react-router-dom"; //not work on current version
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import { Link, useLocation } from "react-router-dom";
import { Navigate, useNavigate } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import Switch from "@mui/material/Switch";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Tooltip from "@mui/material/Tooltip";

import DataTable from "examples/Tables/DataTable";

// Soft UI Dashboard PRO React components
import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiDatePicker from "components/SuiDatePicker";
import SuiEditor from "components/SuiEditor";
import SuiDropzone from "components/SuiDropzone";
import SuiButton from "components/SuiButton";
import DropZone from "components/UpStyled/DropZone";

import DeleteForeverRoundedIcon from "@mui/icons-material/DeleteForeverRounded";
import PageviewIcon from "@mui/icons-material/Pageview";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import EmailIcon from "@mui/icons-material/Email";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useForm, Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import toast from "react-hot-toast";
import "./styles.css";
import ServicesRequired from "pages/de/project/create-project/components/ServicesRequired";
import StyleCard from "components/UpStyled/StyleCard";
import ImportStyleSingleModal from "pages/de/project/create-project/components/ImportStyleSingleModal";
import EditRecordModal from "pages/de/project/create-project/components/EditRecordModal";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";

import { budgetOptions } from "utils/data";

import CategoryContext from "context/category-context";
import { StoreContext } from "context/store";
import { AccountContext } from "context/account";

import MyProjectsContext from "context/my-projects";

import qs from "query-string";
import { nanoid } from "nanoid";
import api from "services/api";
import SuiBadge from "components/SuiBadge";
import moment from "moment";

import PhoneInput from "react-phone-number-input";
import { isPossiblePhoneNumber, formatPhoneNumberIntl } from "react-phone-number-input";
import { handleUploadFiles, getStyleImages, canResizeImageUrl } from "utils/imageHelper";

const PROJECT_NAME_MAX_LENGTH = 80;
const PROJECT_DESC_MAX_LENGTH = 4000;
const MAX_STYLES_COUNT = 12;
const MAX_STYLES_COUNT_ERR_MESSAGE = `You can only have at most ${MAX_STYLES_COUNT} styles in one project`;
const LEAVE_CONFIRM_MESSAGE = `Are you sure to discard changes?`;

const MAX_STYLE_NUMBER_COUNT = 12;
const MAX_TAG_LENGTH = 40;

const CreateProject = ({ edit = false, duplicate = false, preImportStyleId = "" }) => {
  const [endDate, setEndDate] = useState();
  const [startDate, setStartDate] = useState();
  const [uploadingStage, setUploadingStage] = useState();

  const [projectName, setProjectName] = useState();
  const [projectDesc, setProjectDesc] = useState();
  const [projectBudget, setProjectBudget] = useState("0~2000");
  const [navUrl, setNavUrl] = useState("");
  const [detail, setDetail] = useState([]); //project detail info, use in edit mode

  const [selectedStyles, setSelectedStyles] = useState([]); //product=style
  const [importStyleVisible, setImportStyleVisible] = useState(false);
  const [othersFiles, setOthersFiles] = useState([]);
  const [preImportStyle, setPreImportStyle] = useState({});

  const [phone, setPhone] = useState();

  const serviceRef = useRef();
  const addStyleRef = useRef();

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    watch,
    getValues,
    reset,
    formState: { errors },
    control,
  } = useForm();

  let location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const projectId = urlObj?.query?.id;
  const styleId = urlObj?.query?.import_style || preImportStyleId;

  const todayDate = new Date();

  const {
    tree,
    actions: { refreshCategoryTree, findParents, findNodeByID },
  } = useContext(CategoryContext);

  const { store } = useContext(StoreContext);
  const account = useContext(AccountContext);

  const { handleRefresh } = useContext(MyProjectsContext);

  useEffect(() => {
    refreshCategoryTree();
  }, []);

  useEffect(() => {
    if (projectId && (edit || duplicate)) {
      retrieveProjectDetail(projectId);
    }
    if (styleId) {
      retrieveStyleDetail(styleId);
    }
  }, [projectId, styleId]);

  useEffect(() => {
    const serviceState = serviceRef.current || {};
    const business_phone =
      detail?.metadata?.business_phone || store?.metadata?.business_phone || "";

    const email = detail?.metadata?.business_email || account?.email;

    if (edit || duplicate) {
      let projectName = detail.name;
      if (duplicate) {
        projectName = projectName;
      }
      reset({
        name: projectName,
        description: detail.description,
        budget_min: detail?.quote?.budget_min,
        budget_max: detail?.quote?.budget_max,
        category: detail?.metadata?.category,
        servicesDescription: detail?.quote?.services_description,
        business_phone: business_phone,
        email: email,
      });
      setStartDate(detail?.quote?.desired_start_date);
      setEndDate(detail?.quote?.desired_end_date);
      setProjectBudget(detail?.quote?.budget);
      setProjectName(detail.name);
      setProjectDesc(detail.description);
      setValue("budget", detail?.quote?.budget);
      setOthersFiles(detail?.metadata?.othersFiles || []);
      setPhone(business_phone);

      const services_offered = detail?.quote?.services_required || {};
      const steps = Object.keys(services_offered); //services stages
      let initialTags = {};
      let initialChecked = {};

      for (let i = 0; i < steps.length; i++) {
        initialTags[steps[i]] = services_offered[steps[i]]["tags"];
        initialChecked[steps[i]] = true;
      }
      serviceState.setSelectedTags(initialTags);
      serviceState.setChecked(initialChecked);
      serviceState.setServiceDesc(detail?.quote?.services_description);
      //set style initial values
      const initialStyles = detail?.products || [];

      const initialFormattedStyles = initialStyles.map((x) => {
        let quantityName = `${x.id}.quantity`;
        const costPerUnitName = `${x.id}.cost_per_unit`;
        setValue(quantityName, x?.style?.quantity);
        setValue(costPerUnitName, x?.style?.cost_per_unit);
        return {
          productid: x?.id,
          title: x?.title,
          status: x.status,
          type: x?.type?.value ? x?.type?.id : x?.type,
          description: x?.description,
          style: {
            ...x?.style,
            style_number: x?.style?.style_number,
            quantity: x?.style?.quantity,
            cost_per_unit: x?.style?.cost_per_unit,
            color_way: x?.style?.color_way,
            size: x?.style?.size,
            sketchesFiles: x?.style?.sketchesFiles,
            techPacksFiles: x?.style?.techPacksFiles,
            imageFiles: x?.style?.imageFiles,
          },
        };
      });

      setSelectedStyles(initialFormattedStyles);
    } else {
      reset();
      reset({
        budget: "0~2000",
        budget_min: "0",
        budget_max: "2000",
        business_phone: business_phone,
        email: email,
      });
      setStartDate();
      setEndDate();
      setProjectName("");
      setProjectDesc("");
      setProjectBudget("0~2000");
      setPhone(business_phone);

      serviceState.setSelectedTags({});
      serviceState.setChecked({});
      serviceState.setServiceDesc("");
      setOthersFiles([]);
    }
  }, [detail, edit, duplicate]);

  useEffect(() => {
    if (styleId) {
      setSelectedStyles([preImportStyle]);
    }
  }, [preImportStyle.id]);

  const getStyleTableRow = (item) => {
    const styleMeta = item?.style || {};

    let category = item?.type || "N/A";
    let path = [];
    if (typeof category == "object") {
      category = category?.value;
    } else {
      const categoryNode = findNodeByID(tree, category);

      category = categoryNode?.label || category;
    }

    let styleImages = getStyleImages(item, true);
    return {
      key: item.id || item.productid,
      image: styleImages[0],
      name: item.title,
      style_number: styleMeta?.style_number,
      category: category,
      cost_per_unit: styleMeta?.cost_per_unit,
      quantity: styleMeta?.quantity,
      action: item,
    };
  };
  const rows = useMemo(
    () => selectedStyles.map((item) => getStyleTableRow(item)),
    [selectedStyles]
  );

  //=====================================================================
  //Functions
  //=====================================================================

  const retrieveProjectDetail = async (id) => {
    try {
      const { data } = await api.project.get(urlObj?.query?.id);
      const project = data["project"] ? data["project"] : {};
      if (!project.id) {
        setNavUrl("/produce/all-projects", { replace: true });
      }
      setDetail(project);
    } catch (err) {
      setNavUrl("/produce/all-projects");
      console.log(err);
    }
  };

  const retrieveStyleDetail = async (styleId) => {
    try {
      if (styleId) {
        const { data } = await api.products.listStyles({ id: styleId });
        const products = data["products"] ? data["products"] : [];

        let product = products?.[0] || [];

        if (product?.id) {
          product.title = product.title;
          //add default quantity and target_cost
          if (!product.style) {
            product.style = {};
          }
          product.style.quantity = 0;
          product.style.cost_per_unit = 0;
          product.productid = product.id;
        }
        setPreImportStyle(product);
      }
    } catch (err) {
      console.log(err);
      toast.error(`Retrieve style detail failed`);
    }
  };

  const handleUploadFiles = async (files, stage) => {
    const newNameMap = {};
    const newTypeMap = {};
    let newFiles = [...files];
    let uploadQueue = [];
    let oldFiles = [];
    for (let i = 0; i < newFiles.length; i++) {
      if (!newFiles[i].url) {
        // deal with dropped files
        let ext = newFiles[i].name.slice(newFiles[i].name.lastIndexOf("."));
        let newFileName = nanoid() + ext;
        newNameMap[newFileName] = newFiles[i].name;
        newTypeMap[newFileName] = newFiles[i].type;
        newFiles[i] = new File([newFiles[i]], newFileName, { type: newFiles[i].type });
        uploadQueue.push(newFiles[i]);
      } else {
        //won't do anything for existing files
        //existing file format {name:"xxx.xx",type:"image/png",url:"xxx"}
        oldFiles.push(newFiles[i]);
      }
    }

    try {
      setUploadingStage(stage);
      if (uploadQueue && uploadQueue.length > 0) {
        const uploadedUrls = await api.uploads.create(uploadQueue).then(({ data }) => {
          const uploaded = data.uploads.map(({ url }) => {
            let dirArr = url.split("/");
            let name = dirArr[dirArr.length - 1];
            return { name: newNameMap[name], url: url, type: newTypeMap[name] };
          });
          return uploaded;
        });
        return [...oldFiles, ...uploadedUrls];
      } else {
        return [...oldFiles];
      }
    } catch (err) {
      console.log(err);
      return [];
    }
  };

  //styles will be saved only after create the project
  const handleCreateProject = async (data) => {
    const serviceState = serviceRef.current || {};
    let services_required = {};
    /**
     * checked,5 steps
        Ideation: true
        Production: true
        Sampling: true
        Sourcing: false
        Technical Design: true
     */
    const steps = Object.keys(serviceState.checked); //services stages

    for (let i = 0; i < steps.length; i++) {
      if (serviceState.checked[steps[i]] == true) {
        services_required[steps[i]] = {
          tags: serviceState.selectedTags[steps[i]],
        };
      }
    }
    let projectBudget = data["budget"];
    let budget_min = 0;
    let budget_max = 0;
    if (data["budget"] == "others") {
      projectBudget = data["budget_min"] + "~" + data["budget_max"];
      budget_min = Number(data["budget_min"]);
      budget_max = Number(data["budget_max"]);
    } else {
      const budgetRange = data["budget"].split("~");
      budget_min = budgetRange.length > 0 ? Number(budgetRange[0]) : budget_min;
      budget_max = budgetRange.length > 1 ? Number(budgetRange[1]) : "";
    }

    if (budget_max && budget_min > budget_max) {
      return toast.error("Minimal budget cost can not be greater than the maxmium cost!");
    }
    if (data["business_phone"]) {
      const phoneNum = formatPhoneNumberIntl(data["business_phone"]);
      if (!isPossiblePhoneNumber(phoneNum)) {
        return toast.error("Not a valid phone number!");
      }
    }

    let myStartDate = startDate && typeof startDate == "object" ? startDate[0] : startDate;
    let myEndDate = endDate && typeof endDate == "object" ? endDate[0] : endDate;

    myStartDate = moment(myStartDate);
    myEndDate = moment(myEndDate);

    if (myStartDate > myEndDate) {
      return toast.error("Start date cannot be later than the end date!");
    }

    let newStyles = []; //store uploaded files for each style and style detail information
    let othersFilesUrl = []; //store other reference files
    //Uploading supporting files for each style
    try {
      for (let i = 0; i < selectedStyles.length; i++) {
        let newStyle = {};
        const sketchesFiles = selectedStyles[i]?.style?.sketchesFiles || [];
        const techPacksFiles = selectedStyles[i]?.style?.techPacksFiles || [];
        const imageFiles = selectedStyles[i]?.style?.imageFiles || [];

        const sketchesFilesUrl =
          sketchesFiles.length > 0
            ? await handleUploadFiles(sketchesFiles, selectedStyles[i]?.title)
            : [];
        const techPacksFilesUrl =
          techPacksFiles.length > 0
            ? await handleUploadFiles(techPacksFiles, selectedStyles[i]?.title)
            : [];
        const imageFilesUrl =
          imageFiles.length > 0
            ? await handleUploadFiles(imageFiles, selectedStyles[i]?.title)
            : [];

        const productId = selectedStyles[i].productid;

        const quantity = Number(data[productId]?.quantity);
        const cost_per_unit = Number(data[productId]?.cost_per_unit);
        if (isNaN(quantity)) {
          return toast.error("Quantity is not a valid number!");
        }
        if (isNaN(cost_per_unit)) {
          return toast.error("Target unit cost is not a valid number!");
        }

        if (quantity < 0) {
          return toast.error("Quantity must be greater than 0!");
        }

        if (cost_per_unit < 0) {
          return toast.error("Target unit cost must be greater than 0!");
        }

        //Only keep useful fields for orignal records(style import from products)
        newStyle = {
          title: selectedStyles[i].title,
          status: "design",
          type_id: selectedStyles[i].type,
          description: selectedStyles[i].description,

          style: {
            ...selectedStyles[i]?.style,
            style_number: selectedStyles[i]?.style?.style_number,
            quantity: quantity,
            cost_per_unit: cost_per_unit,
            color_way: selectedStyles[i]?.style?.color_way,
            size: selectedStyles[i]?.style?.size,
            sketchesFiles: sketchesFilesUrl,
            techPacksFiles: techPacksFilesUrl,
            imageFiles: imageFilesUrl,
            brand: selectedStyles[i]?.style?.brand,
            year: selectedStyles[i]?.style?.year ? moment(selectedStyles[i]?.style.year) : null,
            season: selectedStyles[i]?.style?.season,
          },
        };

        //if the style already exists, then keep the id field and do update for this style
        if (selectedStyles[i]?.productid) {
          newStyle["id"] = selectedStyles[i].productid;
        }
        newStyles.push(newStyle);
      }
      // uploading reference files

      othersFilesUrl = othersFiles.length > 0 ? await handleUploadFiles(othersFiles, "others") : [];
      setUploadingStage();
    } catch (err) {
      setUploadingStage();
      console.log(err);
      return toast.error("Uploading supporting files failed");
    }

    const preMetadata = detail?.metadata || {};
    let productIds = [];
    if (edit && detail.products && detail.products.length > 0) {
      productIds = detail.products.map((x) => x.id);
    }

    let updated_products = newStyles.filter((x) => productIds.includes(x.id));
    let original_products = newStyles.filter((x) => !productIds.includes(x.id));

    const payload = {
      name: data["name"],
      description: data["description"],
      quote: {
        budget: data["budget"],
        budget_min: budget_min,
        budget_max: budget_max,
        services_required: services_required, //service tag designer needed
        services_description: data["servicesDescription"], //description for selected services
        desired_start_date: myStartDate,
        desired_end_date: myEndDate,
      },
      metadata: {
        ...preMetadata,
        othersFiles: othersFilesUrl,
        business_phone: data["business_phone"],
        email: data["email"],
      },
      products: original_products, //products are same as styles
      updated_products: updated_products, //products that be edited at create project process
    };

    let errorMessage = "Your Project information could not be saved!";
    try {
      let id = null;
      let status = "init";

      let successMessage = "Your Project information has been successfully saved!";

      if (edit) {
        status = detail.status;
        payload.metadata.last_updated_at = new Date();
        console.log(detail.id, payload);
        const { data } = await api.project.update(detail.id, payload);

        successMessage = "Your Project information has been successfully edited!";
        toast.success(successMessage);

        id = detail?.id;
      } else {
        payload.metadata.created_at = new Date();
        const { data } = await api.project.create(payload);
        toast.success(successMessage);

        id = data?.created?.id;
      }
      handleRefresh();

      if (id) {
        //setNavUrl(`/designers/publish-project?id=${id}`);
        //directly go to project detail page
        setNavUrl(`/produce/all-projects?id=${id}`);
      } else {
        setNavUrl("/produce/all-projects");
      }
    } catch (err) {
      console.log(err);
      if (edit) {
        errorMessage = "Your Project information could not be edited!";
      }
      toast.error(errorMessage);
    }
  };

  if (navUrl) {
    return <Navigate to={navUrl} />;
  }

  const handleImportStyle = (data) => {
    const myStyles = data || {};

    if (!myStyles.style) {
      myStyles.style = {};
    }
    let newStyles = {
      productid: myStyles?.id,
      title: myStyles?.title,
      status: "design",
      type: myStyles?.type,
      description: myStyles?.description,
      style: {
        ...myStyles?.style,
        style_number: myStyles?.style?.style_number,
        quantity: myStyles?.style?.quantity,
        cost_per_unit: myStyles?.style?.cost_per_unit,
        color_way: myStyles?.style?.color_way,
        size: myStyles?.style?.size,
        sketchesFiles: myStyles?.style?.sketchesFiles,
        techPacksFiles: myStyles?.style?.techPacksFiles,
        imageFiles: myStyles?.style?.imageFiles,
        brand: myStyles?.style?.brand,
        year: myStyles?.style?.year ? moment(myStyles?.style.year) : null,
        season: myStyles?.style?.season,
      },
    };

    setSelectedStyles([...selectedStyles, newStyles]);
    setImportStyleVisible(false);
  };

  const handleDeleteStyle = (index) => {
    const newStyles = selectedStyles.filter((x, inx) => index != inx);
    setSelectedStyles(newStyles);
  };

  const handleChangePhoneNumber = (value) => {
    setValue("business_phone", value);
    setPhone(value);
  };

  const columns = [
    {
      Header: "Image",
      accessor: "image",
      align: "center",
      width: 60,
      Cell: ({ row, value }) => {
        return (
          <Link
            to={`/workspace/styles-master?id=${row?.original?.key}&stage=design${
              edit ? `&pid=${projectId}` : ""
            }`}
          >
            <ImageCardWrapper data={value} mode={"normal"} height={60} width={60} iconMode />
          </Link>
        );
      },
    },
    {
      Header: "Style No.",
      accessor: "style_number",
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word", maxWidth: 100 }}>{value}</div>;
      },
    },
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word", maxWidth: 160 }}>{value}</div>;
      },
    },

    {
      Header: "Category",
      accessor: "category",
      Cell: ({ row, value }) => {
        return <div style={{ wordBreak: "break-word", maxWidth: 80 }}>{value}</div>;
      },
    },

    {
      Header: "Target Unit Cost",
      accessor: "cost_per_unit",
      resizable: true,
      Cell: ({ row, value }) => {
        return (
          <SuiBox sx={{ maxWidth: 150 }}>
            <SuiInput
              icon={{ direction: "left", component: <AttachMoneyIcon fontSize="sm" /> }}
              type="number"
              {...register(`${row?.original?.key}.cost_per_unit`)}
              required
              inputProps={{
                min: 0,
              }}
            />
          </SuiBox>
        );
      },
    },
    {
      Header: "Quantity",
      accessor: "quantity",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => {
        return (
          <SuiBox sx={{ maxWidth: 120 }}>
            <SuiInput
              type="number"
              {...register(`${row?.original?.key}.quantity`)}
              required
              inputProps={{
                min: 0,
              }}
            />
          </SuiBox>
        );
      },
    },
    {
      Header: "More",
      accessor: "action",
      isSorted: false,
      canSort: false,
      Cell: ({ row, value }) => (
        <SuiBox display="flex" alignItems="center" justifyContent="center" gap={0.5}>
          <Tooltip title="View Details">
            <SuiBox
              component={Link}
              to={`/workspace/styles-master?id=${row?.original?.key}&stage=design${
                edit ? `&pid=${projectId}` : ""
              }`}
            >
              <ManageSearchIcon fontSize={"small"} color="dark" />
            </SuiBox>
          </Tooltip>
          |{" "}
          <Tooltip title="Delete">
            <SuiBox>
              <DeleteForeverRoundedIcon
                fontSize={"small"}
                color="error"
                sx={{ cursor: "pointer" }}
                onClick={(e) => {
                  e.stopPropagation();
                  const newStyles = selectedStyles.filter(
                    (x, inx) => x.productid != row?.original?.key
                  );
                  setSelectedStyles(newStyles);
                }}
              />{" "}
            </SuiBox>
          </Tooltip>
        </SuiBox>
      ),
    },
  ];

  return (
    <div>
      <Backdrop sx={{ color: "info", zIndex: (theme) => 99999 }} open={uploadingStage}>
        <CircularProgress color="info" sx={{ mr: 1 }} size={32} />
        <SuiTypography variant="h6" fontWeight="medium" color="info">
          Uploading supporting files for {uploadingStage}...
        </SuiTypography>
      </Backdrop>

      <SuiBox mt={1} mb={4}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={11} xl={10} xxl={9}>
            <form onSubmit={handleSubmit(handleCreateProject)}>
              <div className="pb-2">
                <Card sx={{ p: 2 }}>
                  <SuiTypography variant="h5" fontWeight="medium">
                    {edit ? "Edit Project" : "Create a New Project"}
                  </SuiTypography>
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                    {edit
                      ? "You may modify your project here."
                      : duplicate
                      ? `Duplicate project from ${detail.name}`
                      : "Your project can comprise of a single garment or a collection of several garments."}
                  </SuiTypography>

                  <Grid container justifyContent="center" mt={3}>
                    <Grid item xs={12} sm={12} md={12}>
                      <SuiBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                        height="100%"
                      >
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            required
                          >
                            Project Name
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput
                          componentsProps={{
                            input: {
                              maxlength: PROJECT_NAME_MAX_LENGTH,
                            },
                          }}
                          required
                          {...register("name", {
                            value: projectName,

                            onChange: (e) => {
                              setProjectName(e.target.value);
                            },
                          })}
                          placeholder="Help our Manufacturers/Specialists easily discover your project by giving it a name."
                        />
                        <SuiBox display="flex" justifyContent="space-between">
                          <div></div>
                          <SuiTypography
                            variant="text"
                            color="secondary"
                            fontWeight="regular"
                            fontSize="14px"
                          >
                            {projectName ? projectName.length : 0}/{PROJECT_NAME_MAX_LENGTH}
                          </SuiTypography>
                        </SuiBox>
                      </SuiBox>
                    </Grid>
                  </Grid>

                  <SuiBox pb={2}>
                    <SuiBox
                      display="flex"
                      flexDirection="column"
                      justifyContent="flex-end"
                      height="100%"
                    >
                      <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography component="label" variant="caption" fontWeight="bold">
                          Styles
                        </SuiTypography>
                      </SuiBox>
                      <SuiBox ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                        <SuiTypography
                          component="label"
                          variant="caption"
                          fontWeight="regular"
                          color="text"
                        >
                          Import Styles directly from your Style Master. You can have up to{" "}
                          {MAX_STYLES_COUNT} Styles for each Project
                        </SuiTypography>
                      </SuiBox>
                    </SuiBox>
                    <SuiBox
                      display="flex"
                      justifyContent="flex-start"
                      alignItems="center"
                      sx={{ flexWrap: "wrap" }}
                      gap={1}
                      mt={1}
                    >
                      <SuiButton
                        variant="gradient"
                        color="dark"
                        onClick={() => {
                          if (selectedStyles.length >= MAX_STYLES_COUNT) {
                            return toast.error(MAX_STYLES_COUNT_ERR_MESSAGE);
                          }
                          setImportStyleVisible(true);
                        }}
                      >
                        Import Styles
                      </SuiButton>
                    </SuiBox>
                    <SuiBox
                      sx={({ borders }) => ({
                        mt: 2,
                        borderColor: borders.borderColor,
                        borderRadius: "10px",
                        border: "dashed 1px",
                        minHeight: "340px",
                      })}
                    >
                      <DataTable
                        table={{ columns, rows: rows }}
                        entriesPerPage={{ defaultValue: 50 }}
                        showTotalEntries={false}
                        pagination={false}
                        noEndBorder
                        isSorted={false}
                      />

                      {/* <SuiBox
                        display="flex"
                        alignItems="center"
                        justifyContent="flex-start"
                        gap={1}
                        sx={{ flexWrap: "wrap" }}
                      >
                        {selectedStyles.map((p, inx) => (
                          <SuiBox key={inx}>
                            <StyleCard
                              product={p}
                              onDeleteStyle={() => handleDeleteStyle(inx)}
                              onEditStyle={() =>
                                edit
                                  ? setNavUrl(
                                      `/workspace/styles-master?id=${p.productid}&&pid=${detail.id}`
                                    )
                                  : handleShowEditStyle(p)
                              }
                              onEditRecord={(editKey) => handleShowEditRecord(p, editKey)}
                              collectionsInfo={[]}
                            ></StyleCard>
                          </SuiBox>
                        ))}
                      </SuiBox> */}
                    </SuiBox>
                  </SuiBox>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox ml={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography component="label" variant="caption" fontWeight="bold" required>
                        Total Budget
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox mb={1.5} ml={0.5} mt={0.5} lineHeight={0} display="inline-block">
                      <SuiTypography
                        component="label"
                        variant="caption"
                        fontWeight="regular"
                        color="text"
                      >
                        Tell us your budget for this project
                      </SuiTypography>
                    </SuiBox>
                    <SuiBox
                      ml={1.5}
                      lineHeight={0}
                      className="flex items-center"
                      sx={{ minHeight: 30 }}
                    >
                      <Controller
                        name="budget"
                        control={control}
                        rules={{ required: "A budget is required for this project!" }}
                        render={({
                          field: { onChange, onBlur, value, name, ref },
                          fieldState: { invalid, isTouched, isDirty, error },
                          formState,
                        }) => (
                          <RadioGroup
                            row
                            value={projectBudget}
                            defaultValue={projectBudget}
                            onChange={(e) => {
                              onChange(e);
                              setProjectBudget(e.target.value);
                            }}
                            ref={ref}
                            className="gap-3 items-center"
                          >
                            {budgetOptions.map((option, index) => (
                              <SuiBox className="flex items-center mr-2">
                                <Radio value={option.value} key={index} />
                                <SuiTypography
                                  component="label"
                                  variant="button"
                                  fontWeight="bold"
                                  color="dark"
                                >
                                  {option.label}
                                </SuiTypography>
                              </SuiBox>
                            ))}

                            <SuiBox className="flex items-center mr-2">
                              <Radio value="others" />
                              <SuiTypography
                                component="label"
                                variant="button"
                                fontWeight="bold"
                                color="dark"
                              >
                                <div className="flex items-center gap-2">
                                  <div>Others</div>
                                  {projectBudget == "others" ? (
                                    <div className="flex items-center">
                                      <SuiInput
                                        sx={{ maxWidth: 100 }}
                                        icon={{
                                          direction: "left",
                                          component: <AttachMoneyIcon fontSize="sm" />,
                                        }}
                                        placeholder="Min"
                                        size="small"
                                        type="number"
                                        inputProps={{ step: 0.01, min: 0 }}
                                        required
                                        {...register("budget_min")}
                                      />
                                      <Divider style={{ width: 20 }} />
                                      <SuiInput
                                        sx={{ maxWidth: 100 }}
                                        icon={{
                                          direction: "left",
                                          component: <AttachMoneyIcon fontSize="sm" />,
                                        }}
                                        placeholder="Max"
                                        size="small"
                                        type="number"
                                        inputProps={{ step: 0.01, min: 0 }}
                                        required
                                        {...register("budget_max")}
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              </SuiTypography>
                            </SuiBox>
                          </RadioGroup>
                        )}
                      />
                    </SuiBox>
                    <div></div>
                  </SuiBox>

                  <Grid container columnSpacing={3}>
                    <Grid item xs={6}>
                      <SuiBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                        height="100%"
                      >
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Desired Start Date
                          </SuiTypography>
                        </SuiBox>
                        <SuiDatePicker
                          value={startDate}
                          onChange={setStartDate}
                          options={{ minDate: todayDate }}
                          input={{ placeholder: moment(todayDate).format("yyyy-MM-DD") }}
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={6}>
                      <SuiBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                        height="100%"
                      >
                        <SuiBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Desired End Date
                          </SuiTypography>
                        </SuiBox>
                        <SuiDatePicker
                          value={endDate}
                          onChange={setEndDate}
                          options={{ minDate: todayDate }}
                          input={{ placeholder: moment(todayDate).format("yyyy-MM-DD") }}
                        />
                      </SuiBox>
                    </Grid>
                  </Grid>
                  <SuiBox
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    height="100%"
                  >
                    <SuiBox mb={1} ml={0.5} mt={2} lineHeight={0} display="inline-block">
                      <SuiTypography component="label" variant="caption" fontWeight="bold">
                        Project Description
                      </SuiTypography>
                    </SuiBox>

                    <SuiInput
                      multiline
                      rows="5"
                      componentsProps={{ input: { maxlength: PROJECT_DESC_MAX_LENGTH } }}
                      {...register("description", {
                        value: projectDesc,
                        onChange: (e) => {
                          setProjectDesc(e.target.value);
                        },
                      })}
                      placeholder="Include any important information that you want Manufacturers/Specialists to know about this project."
                    />

                    <SuiBox display="flex" justifyContent="space-between">
                      <div></div>
                      <SuiTypography
                        variant="text"
                        color="secondary"
                        fontWeight="regular"
                        fontSize="14px"
                      >
                        {projectDesc ? projectDesc.length : 0}/{PROJECT_DESC_MAX_LENGTH}
                      </SuiTypography>
                    </SuiBox>
                  </SuiBox>
                </Card>
              </div>
              <div className="pb-2">
                <Card sx={{ p: 2 }}>
                  <SuiTypography variant="h6" fontWeight="medium">
                    Services Needed
                  </SuiTypography>
                  <SuiTypography variant="button" fontWeight="regular" color="text">
                    Please select the services you need to make your collection come to life.
                  </SuiTypography>
                  <ServicesRequired register={register} ref={serviceRef} />
                </Card>
              </div>
              <div className="pb-2">
                <Card sx={{ p: 2 }}>
                  <div className="pb-2">
                    <SuiTypography variant="h6" fontWeight="medium">
                      Reference Files
                    </SuiTypography>
                    <SuiTypography variant="button" fontWeight="regular" color="text">
                      You could share your additional files with manufacturers here.
                    </SuiTypography>
                    <DropZone files={othersFiles} setfiles={setOthersFiles} />
                  </div>
                </Card>
              </div>
              <Card sx={{ p: 2 }}>
                <div className="pb-2">
                  <SuiTypography variant="h6" fontWeight="medium">
                    Contact Information
                  </SuiTypography>

                  <Grid container columnSpacing={3}>
                    <Grid item xs={6} sm={6} md={6}>
                      <SuiBox
                        display="flex"
                        flexDirection="column"
                        justifyContent="flex-end"
                        height="100%"
                      >
                        <SuiBox mb={1} ml={0.5} lineHeight={1} display="inline-block">
                          <SuiTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                          >
                            Phone Number
                          </SuiTypography>
                        </SuiBox>
                        <PhoneInput
                          label="Phone"
                          className="upstyled-phone-input h-10 px-2 rounded-lg"
                          placeholder="Enter phone number"
                          name="business_phone"
                          value={phone}
                          defaultCountry="US"
                          {...register("business_phone")}
                          onChange={handleChangePhoneNumber}
                        />
                      </SuiBox>
                    </Grid>
                    <Grid item xs={6} sm={6} md={6}>
                      <SuiBox display="flex" flexDirection="column" justifyContent="flex-end">
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography component="label" variant="caption" fontWeight="bold">
                            Email
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput
                          type="email"
                          {...register("email")}
                          placeholder="Email"
                          icon={{
                            direction: "left",
                            component: <EmailIcon fontSize="sm" />,
                          }}
                        />
                      </SuiBox>
                    </Grid>
                  </Grid>
                </div>

                <SuiBox display="flex" justifyContent="flex-end" mt={3}>
                  <SuiButton variant="gradient" color="dark" type="submit">
                    {"Save"}
                    <ArrowForwardIcon sx={{ ml: 0.5 }} />
                  </SuiButton>
                </SuiBox>
              </Card>
            </form>
          </Grid>
        </Grid>
      </SuiBox>

      {importStyleVisible ? (
        <ImportStyleSingleModal
          handleClose={() => setImportStyleVisible(false)}
          handleOk={(data) => handleImportStyle(data)}
          visible={importStyleVisible}
        />
      ) : null}
    </div>
  );
};

export default CreateProject;
